package org.gstechnovos.jexonplastech.sections.contact.styles

import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.selectors.focus
import com.varabyte.kobweb.silk.style.selectors.hover
import org.gstechnovos.jexonplastech.theme.toSitePalette
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.s

val ContactFormContainerStyle = CssStyle {
    val palette = colorMode.toSitePalette()
    base {
        Modifier.fillMaxWidth()
            .padding(topBottom = 100.px)
            .backgroundColor(palette.custom.lightGray)
    }
}

val InputStyle = CssStyle {
    val palette = colorMode.toSitePalette()
    base {
        Modifier.fillMaxWidth().padding(16.px).backgroundColor(palette.custom.white)
            .border(1.px, LineStyle.Solid, palette.custom.lightGray).borderRadius(8.px).fontSize(16.px)
            .color(palette.custom.darkText)
            .transition(Transition.of("border-color", 0.3.s), Transition.of("box-shadow", 0.3.s))
            .outline(style = LineStyle.None)
    }
    focus {
        Modifier.border(1.px, LineStyle.Solid, palette.brand.primaryBlue)
            .boxShadow(0.px, 0.px, 0.px, 3.px, color = palette.brand.primarySoft.toRgb().copyf(alpha = 0.5f))
    }
}

val SubmitButtonStyle = CssStyle {
    val palette = colorMode.toSitePalette()
    base {
        Modifier.fillMaxWidth().padding(topBottom = 16.px).backgroundColor(palette.brand.primaryBlue)
            .color(palette.custom.white).borderRadius(8.px).border(style = LineStyle.None)
            .fontWeight(com.varabyte.kobweb.compose.css.FontWeight.Bold).fontSize(18.px).cursor(Cursor.Pointer)
            .transition(Transition.of("background-color", 0.3.s), Transition.of("transform", 0.2.s))
    }
    hover {
        Modifier.backgroundColor(palette.brand.primaryBlueHover).translateY((-2).px)
            .boxShadow(0.px, 10.px, 20.px, color = palette.brand.primaryBlue.toRgb().copyf(alpha = 0.3f))
    }
}